/* tslint:disable */
/* eslint-disable */
/**
 * seller
 * アグリノート米市場 Seller API
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: mazhulin.d@water-cell.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 * 都道府県マスタ
 * @export
 * @interface PrefectureRead
 */
export interface PrefectureRead {
  /**
   * ID
   * @type {number}
   * @memberof PrefectureRead
   */
  readonly id: number
  /**
   * レコードのバージョン番号
   * @type {number}
   * @memberof PrefectureRead
   */
  readonly versionNumber: number
  /**
   * ステータス（true: 有効、false: 無効）
   * @type {boolean}
   * @memberof PrefectureRead
   */
  isActive: boolean
  /**
   * 都道府県名
   * @type {string}
   * @memberof PrefectureRead
   */
  name: string
}

export function PrefectureReadFromJSON(json: any): PrefectureRead {
  return PrefectureReadFromJSONTyped(json, false)
}

export function PrefectureReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrefectureRead {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    versionNumber: json['version_number'],
    isActive: json['is_active'],
    name: json['name'],
  }
}

export function PrefectureReadToJSON(value?: PrefectureRead | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    is_active: value.isActive,
    name: value.name,
  }
}
